import React from "react";
import { useTranslation } from "react-i18next";
import {
  Grid,
  GridNoRecords,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Label } from "@progress/kendo-react-labels";
import { useMediaQuery } from "@material-ui/core";
import "./signature-request-profile-list-authorizer-signers.css";

const TooltipContentTemplate = (props) => {
  return (
    <a>
      <p>{props.content}</p>
    </a>
  );
};

/* === Custom Component for th elements of the Grid === */
const signerOneHeader = (props) => {
  const cellHeaderStyles = {
    color: "#427FBA",
    fontSize: "14px",
    fontFamily: "Quicksand, sans-serif",
    fontWeight: 600,
    display: "flex",
    justifyContent: "start",
  };
  return <span className="" style={cellHeaderStyles}>{props.title}</span>;
};

const signerHeaderOthers = (props) => {
  const cellHeaderStyles = {
    color: "#427FBA",
    fontSize: "14px",
    fontFamily: "Quicksand, sans-serif",
    fontWeight: 600,
    display: "flex",
    justifyContent: "start",
  };
  return <span className="" style={cellHeaderStyles}>{props.title}</span>;
};

/* === Custom componente for td elements of the Grid === */
const signerCell = (props) => {
  return (
    <td className='signatureRequestProfileListSignersPure-cell-one'>
      <div className="">
        <p className='signatureRequestProfileListSignersPure-column1-title'>
          {props.dataItem.nameCompleted}
        </p>
        <p className='signatureRequestProfileListSignersPure-subtitle-column1'>
          {props.dataItem.email}
        </p>
      </div>
    </td>
  )
};

/* === Custom componente cells SignStatus for td elements of the Grid === */
const signerStatusSignCell = (props) => {
  let colorItem = "";
  if (props.dataItem.signStatusId) {
    if (props.dataItem.signStatusId === 2) {
      colorItem = "#005EA0";
    } else if (props.dataItem.signStatusId === 4) {
      colorItem = "#899232";
    } else if (props.dataItem.signStatusId === 3) {
      colorItem = "#F86A65";
    } else if (props.dataItem.signStatusId === 5) {
      colorItem = "#FF922C";
    } else {
      colorItem = "#4c4c4c";
    }
  }
  const cellItemStyles = {
    color: "#4c4c4c",
    fontSize: "14px",
    textTransform: "uppercase",
  };
  return (
    <td className="signatureRequestProfileListSignersPure-cell-rol-col" style={cellItemStyles}>
      <span style={{ color: `${colorItem}` }}>
        {props.dataItem[props.field]}
      </span>
    </td>
  );
};

const orderStatusCell = (props) => {
  let colorItem = "";
  if (props.dataItem.signStatusId) {
    if (props.dataItem.signStatusId === 2) {
      colorItem = "#005EA0";
    } else if (props.dataItem.signStatusId === 4) {
      colorItem = "#899232";
    } else if (props.dataItem.signStatusId === 3) {
      colorItem = "#F86A65";
    } else if (props.dataItem.signStatusId === 5) {
      colorItem = "#FF922C";
    } else {
      colorItem = "#4c4c4c";
    }
  }
  const cellItemStyles = {
    color: "#4c4c4c",
    fontSize: "14px",
    textTransform: "uppercase",
  };
  return (
    <td className="signatureRequestProfileListSignersPure-cell-order-col" style={cellItemStyles}>
      <span style={{ color: `${colorItem}` }}>
        {props.dataItem[props.field]}
      </span>
    </td>
  );
};

const SignatureRequestProfileListSignersAuthorizerPure = (props) => {
  const { t } = useTranslation();
  const showAdministratorRol = useMediaQuery(props.processTypeId !== 3 ? "(max-width:640px)" : "(max-width:590px)");
  const gridLabelNorecordsStyles = {
    color: "#828282",
    fontSize: "15px",
    fontWeight: 500,
  };

  return (
    <div>
      <Grid
        className="signatureRequestProfileListSignersAuthorizerPure-grid"
        data={props.validators.slice(props.skip, props.take + props.skip)}
        // data={props.signers}
        resizable
        reorderable
      >
        <Column
          field="nameCompleted"
          title={t("gridListSigners.titleName")}
          cell={signerCell}
          headerCell={signerOneHeader}
        />
        {!showAdministratorRol &&
          <Column
            field="typeName"
            title={t("signatureRequestProfileListSigners.rol")}
            cell={signerStatusSignCell}
            headerCell={signerHeaderOthers}
            headerClassName="signatureRequestProfileListSignersPure-cell-rol-header"
          />
        }
        {/* {isAtgrafSignature && isShowIndex && (  */}
        {props.signatureTypeId === 3 &&
          props.processTypeId !== 3 &&
          props.processTypeId !== 4 ? (
          <Column
            title="Cantidad de firmas"
            style={{ width: "50px", fontSize: "12px !important" }}
            cell={({ dataItem }) => {
              return (
                <div className="Tooltip-num">
                  <div
                    style={{ marginTop: "8px", fontSize: "12px !important" }}
                  >
                    <NumericTextBox
                      className="input-add-colaborator"
                      type="name"
                      name="numSign"
                      max={99}
                      style={{ fontSize: "12px" }}
                      min={1}
                      // value={dataItem.numSign || 1}
                      field="numSign"
                      disabled={true}
                    />
                  </div>
                  <Tooltip
                    position="right"
                    anchorElement="target"
                    content={() => (
                      <TooltipContentTemplate
                        content={
                          "Para este documento y este firmante tienes la opción de solicitar más de una firma, si lo deseas aumenta la cantidad de firmas."
                        }
                      />
                    )}
                  >
                    <Label className="form-inputs-labels">
                      {""}
                      <i
                        className="k-icon k-i-information"
                        title={t("signatureRequestView2.tooltipClic")}
                      />
                    </Label>
                  </Tooltip>
                </div>
              );
            }}
          />
        ) : // )}
          null}
        {props.processTypeId !== 3 ? (
          <Column
            field="id_order"
            title={t("Order")}
            cell={orderStatusCell}
            headerCell={signerHeaderOthers}
            headerClassName="signatureRequestProfileListSignersPure-cell-order-header"
          />
        ) : null}
        <GridNoRecords>
          <p style={gridLabelNorecordsStyles}>
            {t("gridListSigners.noDataToShow")}
          </p>
        </GridNoRecords>
      </Grid>
    </div>
  );
};
export { SignatureRequestProfileListSignersAuthorizerPure as default };
